import { Button } from '@/components/ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertCircle, ArrowLeft } from 'lucide-react';

export default function ErrorFallback({ error }: { error: Error }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="max-w-md w-full">
        <CardHeader>
          <div className="flex items-center justify-center w-20 h-20 rounded-full bg-red-100 mx-auto mb-4">
            <AlertCircle className="w-10 h-10 text-red-600" />
          </div>
          <CardTitle className="text-center text-2xl font-bold">Oops! Something went wrong</CardTitle>
        </CardHeader>
        <CardContent className="p-3">
          <p className="text-center text-muted-foreground">{error.message}</p>
        </CardContent>
        <CardFooter className="flex justify-center">
          <Button className="w-full sm:w-auto">
            <ArrowLeft className="mr-2 h-4 w-4" onClick={() => window.location.reload()} /> Go back home
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
